import React, {useState} from "react";
import {validation} from "../../../helpers/ValidationHelper";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";

const defaultMetadata = {
    address: 0
};

function validateAddressValue(value) {
    return value > 0 && value <= 255;
}

export default function SorensenXgMetadata({metadata, onChange, onValidationSuccess, onValidationError}) {
    const model = metadata
        ? Object.assign(defaultMetadata, {
            address: metadata["address"]
        }) : defaultMetadata;

    const [validationErrors, setValidationErrors] = useState({});

    function handleSetValidationErrors(value) {
        setValidationErrors(value);

        Object.keys(value).length
            ? onValidationSuccess()
            : onValidationError();
    }

    function handleAddressChange(event) {
        handleSetValidationErrors(
            validation(
                event.target.value,
                "address",
                validationErrors,
                validateAddressValue
            )
        );

        onChange({"address": event.target.value});
    }

    return (
        <Grid container spacing={2} direction={"column"} justify={"center"} alignItems={"center"}>
            <Grid item xs={12}>
                <TextField
                    id="sorensen-xg-address"
                    type={"number"}
                    label="Address"
                    fullWidth
                    value={model.address}
                    error={validationErrors["address"]}
                    inputProps={{
                        step: 1,
                        style: {textAlign: "center"}
                    }}
                    onChange={handleAddressChange}
                />
            </Grid>
        </Grid>
    );
}